/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * Controls how a section is presented in the client.
 */
export type DisplayMode = typeof DisplayMode[keyof typeof DisplayMode];


export const DisplayMode = {
  banner: 'banner',
  special: 'special',
  regular: 'regular',
} as const;
